import { useDoctorPortalApiContext } from 'contexts/ApiContext';
import { useQuery } from 'react-query';
import { ExaminationBaseDTO, fetchBaseVisit } from '@higo/api';
import { head } from 'rambda/immutable';
import { visitNotificationQueryKeys } from 'config/doctorQueryKey';

export const useNewVisitNotificationQuery = (visitId: number) => {
  const { authorizedAxios } = useDoctorPortalApiContext();

  return useQuery(visitNotificationQueryKeys.details(visitId), () =>
    fetchBaseVisit(authorizedAxios)([visitId]).then(
      (x) => head<ExaminationBaseDTO>(x), 
    ),
  );
};
